import { useEffect } from 'react';
import useUmamiTracker from 'src/application/analitics/umami/useUmamiTracker';

export const PageViewTracker = ({ router }: { router: any }) => {
  const { trackPageview } = useUmamiTracker();

  useEffect(() => {
    if (!router || !router.subscribe) return;

    const unsubscribe = router.subscribe((state: any) => {
      const match = state.matches[state.matches.length - 1];
      const route = match?.route;
      const loc = state.location;

      trackPageview({
        route: route?.path ?? loc.pathname,
        path: state.location.pathname,
        search: loc.search,
      });
    });

    return () => {
      unsubscribe?.();
    };
  }, [router, trackPageview]);

  return null;
};
